export default {
	inboundTransmissions: [],
	outboundTransmissions: []
};